/*
 *   File : aadhaar-fetch-status.js
 *   Author : https://evoqins.com
 *   Description : Aadhaar fetch  status modal component
 *   Integrations : NA
 *   Version : 1.0.0
*/


import { useNavigate } from 'react-router-dom';

//custom component
import { PrimaryButton } from '../Buttons';

//Assets
import Close from "../../Assets/Images/close-btn-white.svg";

const AadhaarFetchStatusModal = (props) => {


    // //handle to navigate home
    // const _handleNavigate = () => {
    //     navigate("/");
    // };


    // // handle close modal 
    // const _handleModalClose = () => {
    //     props.onCloseModal();
    // };

    return (
        <div className="modal fade"
            data-bs-backdrop="static"
            id="aadhaar-fetch-status-modal"
            tabIndex="-1"
            aria-labelledby="aadhaarFetchStatusModalLabel"
            aria-hidden="true">
            <div className="modal-dialog  modal-dialog-centered modal-md " >
                <div className="modal-content e-bg-blur-gradient e-border-radius-24 e-addbank-box-shadow">
                    <div className="modal-header border-0 justify-content-end pt-4 pb-0 px-4 ">
                        <img src={Close}
                            id='aadhaar-fetch-status-modal-close'
                            draggable={false}
                            className='cursor-pointer width-24px width-20px-res'
                            data-bs-dismiss="modal"
                            aria-label="Close"
                            alt='close'
                            onClick={props.onCloseModal}
                        />
                    </div>
                    <div className="modal-body text-center p-4 ">
                        <img src={require("../../Assets/Images/Onboarding/aadhaar-fetch-failure.png")}
                            draggable={false}
                            className='col-5'
                            alt='bank' />
                        <p className='mb-2 pt-4 e-text-sunset-orange e-font-16-res e-font-18 e-alt-font-poppins e-font-weight-600 line-height-24px'>
                            Data Fetching Failed
                        </p>
                        <p className='px-md-4 px-sm-0 px-0 e-text-dark-liver e-font-14 e-alt-font-poppins e-font-weight-400 line-height-24px mb-0 mb-sm-3'>
                            We couldn’t fetch your details right now. You can try again or enter them manually.
                        </p>

                        <div className='padding-40px-top padding-24px-top-res'>
                            <PrimaryButton name="Enter Manually"
                                className="padding-12px-top padding-12px-bottom  col-8 e-font-14 e-font-12-res"
                                dismiss="modal"
                                onPress={props.onCloseModal} />
                        </div>
                    </div>
                </div>
            </div>
        </div>
    )
}

export default AadhaarFetchStatusModal